export const CONTRAT_CONFIG = 'CONTRAT_CONFIG'
export const CONTRAT_CONFIG_SUCCESS = 'CONTRAT_CONFIG_SUCCESS'
export const CONTRAT_CONFIG_FAIL = 'CONTRAT_CONFIG_FAIL'

export default {
  [CONTRAT_CONFIG](state) {
    state.configs_pending = true
  },
  [CONTRAT_CONFIG_SUCCESS](state, config) {
    state.configs[config.getAnnee()] = config
    state.configs_pending = false
  },
  [CONTRAT_CONFIG_FAIL](state) {
    state.configs_pending = false
  }
}
